
import { Component, Prop, VModel, mixins } from 'nuxt-property-decorator'
import {
  NFT_SQUID_SORT_CONDITION_LIST,
  NFT_SQUID_SORT_CONDITION_LIST_FOR_MOONRIVER,
} from '@/utils/constants'
import PrefixMixin from '@/utils/mixins/prefixMixin'
import {
  NeoButton,
  NeoDropdown,
  NeoDropdownItem,
  NeoField,
  NeoSelect,
} from '@kodadot1/brick'

@Component({
  components: {
    NeoButton,
    NeoField,
    NeoSelect,
    NeoDropdown,
    NeoDropdownItem,
  },
})
export default class SearchSortDropdown extends mixins(PrefixMixin) {
  @VModel({ type: [Array, String] }) selectedAction!: string | string[]
  @Prop(Array) public sortOption?: string[]
  @Prop(Boolean) public multipleSelect!: boolean
  @Prop({ type: Boolean, default: false }) public isCollection?: boolean

  get actions(): string[] {
    return this.sortOption || this.sort
  }

  get sort(): string[] {
    if (this.isMoonriver) {
      return NFT_SQUID_SORT_CONDITION_LIST_FOR_MOONRIVER
    }
    return NFT_SQUID_SORT_CONDITION_LIST
  }
}
